module.exports = __webpack_public_path__ + "img/walletcard_logo.77737c1e.png";